import { createOpenStore } from "stores/createOpenStore";
import type { ExportSourceWire } from "@/components/canvas/detailsSide/tableDetails/ExportToSheets/exportApi";

export interface ExportSheetsOpen {
  tableId: string;
  source: ExportSourceWire;
  title: string;
  tabName?: string;
  cellCount?: number;
}

export const useExportSheetsStore = createOpenStore<ExportSheetsOpen>();
